<template>
  <div class="order-toast">
    <div class="order-toast__icon">
      <i class="icon-attantion" />
    </div>
    <div class="order-toast-content">
      <div class="order-toast-content__title">
        Incoming order!
      </div>
      <div class="order-toast-content__text">
        Tariff - {{ content.coach_type }} ${{ content.price }}
      </div>
    </div>
    <div class="order-toast__footer">
      <z-button
        btn-class="btn-success"
        size="small"
        @click="$emit('take', content.order_id)"
      >
        Take order
      </z-button>
      <z-button
        btn-class="btn-default"
        size="small"
        @click="$emit('details', content.order_id)"
      >
        Details
      </z-button>
      <audio
        src="/audio/order-notify.mp3"
        autoplay
        loop
      />
    </div>
  </div>
</template>

<script>
import ZButton from '@/components/shared/buttons/ZButton.vue';

export default {
  name: 'OrderToastComponent',

  components: {
    ZButton,
  },

  props: {
    content: {
      type: Object,
      default: null,
    },
  },

};
</script>

<style lang="scss">
  .order-toast {
    display: grid;
    grid-template-columns: 30px 1fr;
    grid-template-rows: auto auto;
    gap: 24px 24px;
    grid-template-areas:
      "area-1 area-2"
      "area-3 area-3";

    &__icon {
      padding-top: 5px;
      font-size: 30px;
      color: #434c57;
    }

    .order-toast-content {

      &__title {
        color: #fb9624;
        font-size: 18px;
        text-transform: uppercase;
        font-family: var(--font-bold);
      }

      &__text {
        font-size: 14px;
        text-transform: uppercase;
        font-family: var(--font-bold);
      }
    }

    &__footer {
      grid-area: area-3;
      display: flex;

      .btn {
        margin-right: 10px;
      }
    }

  }

</style>
